// All needed imports
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { HomeModule } from '../home/home.module';
import { PUAInsurancesModule } from '../pua-insurances.module';
import { TranslateModule } from '@ngx-translate/core';
import { HomeComponent } from '../home/home.component';
import { HeaderComponent } from './components/header/header.component';
import { MainComponent } from './components/main/main.component';
import { FooterComponent } from './components/footer/footer.component';
import { LayoutComponent } from './layout.component';
import { Error404Component } from './components/error404/error404.component';
import { NavigatorIncompatibleComponent } from './components/navigator-incompatible/navigator-incompatible.component';
import { PolizasEmitirService } from '../../../app/core/providers/services/polizas-emitir/polizas-emitir.service';
import { ServicesTokenService } from '../../core/providers/services/services-token/services-token.service';
import { PresupuestoRecuperarService } from '../../../app/core/providers/services/presupuesto-recuperar/presupuesto-recuperar.service';

@NgModule({
  // Declarate the needed components
  declarations: [
    LayoutComponent, HomeComponent, HeaderComponent, MainComponent, FooterComponent,
    Error404Component, NavigatorIncompatibleComponent ],
  // Import modules which will be used in this module
  imports: [
    SharedModule,
    PUAInsurancesModule,
    TranslateModule
  ],
  // Indicate the modules which will be used in other modules
  exports: [
    TranslateModule
  ],
  // Declarate the services used
  providers: [
    PolizasEmitirService,
    ServicesTokenService,
    PresupuestoRecuperarService
  ]
})
export class LayoutModule {
}
